export default "__VITE_ASSET__Cm_Scyun__"